module.exports = __webpack_public_path__ + "static/media/react-bootstrap-carousel.2fe6d179.svg";